import { isMobile, isTablet } from "react-device-detect";

const DetectDevice = (() =>
{
    if (isMobile && !isTablet){
        return 1
    }
    else {
        return 0
    }
})();

export default DetectDevice;